import React, { PureComponent } from "react";
import { connect } from "react-redux";

import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MenuIcon from "@material-ui/icons/Menu";

import withStyles from '@material-ui/styles/withStyles';
import { Auth } from "aws-amplify";
import classNames from "classnames";

const drawerWidth = 240;

const styles = theme => ({
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  menuButtonHidden: {
    display: "none"
  },
  title: {
    flexGrow: 1
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
});

class AdminNavigationBar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  signOut = async () => {
    try {
      await Auth.signOut();
      localStorage.removeItem("user");
      this.props.history.push("/");
    } catch (error) {
      console.log(error);
    }
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { classes } = this.props;
    return (
      <AppBar
        position="absolute"
        className={classNames(
          classes.appBar,
          this.props.open && classes.appBarShift
        )}
        elevation={1}
      >
        <Toolbar disableGutters={!this.props.open} className={classes.toolbar}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={this.props.handleDrawer}
            className={classNames(
              classes.menuButton,
              this.props.open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classNames(this.props.open && classes.menuButtonHidden)}
          >
            DentistFind
          </Typography>
          <div style={{flexGrow: 1}}/>
          <IconButton
            aria-haspopup="true"
            color="inherit"
            onClick={this.handleClick}
          >
            <AccountCircleIcon />
          </IconButton>
          {/* <Button color="inherit" onClick={this.signOut}>
            Sign out
          </Button> */}
          <Popover
            id="simple-popper"
            open={open}
            anchorEl={anchorEl}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
          >
            <div style={{ width: 250, padding: 15 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: 'column'
                }}
              >
                <Avatar
                  style={{
                    backgroundColor: "rgba(67, 160, 71,0.3)",
                    color: "rgb(67, 160, 71)",
                    height: 60,
                    width: 60,
                    fontSize: 30,
                    marginBottom:10
                  }}
                >
                  {this.props.auth.initials}
                </Avatar>

                <Typography
                  component="h1"
                  variant="h5"
                  color="inherit"
                  noWrap
                  style={{
                    fontWeight: '500'
                  }}
                >
                  {this.props.auth.fullName}
                </Typography>
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="inherit"
                  noWrap
                  style={{
                    fontStyle: 'italic',
                  }}
                >
                  {this.props.auth.email}
                </Typography>
                <Button
                  color="primary"
                  style={{ marginTop: 10}}
                  onClick={this.signOut}
                >
                  Sign out
                </Button>
              </div>
            </div>
          </Popover>
        </Toolbar>
      </AppBar>
    );
  }
}

const StyledComponent = withStyles(styles)(AdminNavigationBar);

const mapStateToProps = state => {
  return {
    auth: state.auth.user
  };
};

export default connect(mapStateToProps)(StyledComponent);
